module.exports = __webpack_public_path__ + "img/honor_002.4ce8fe3.webp";